import React, { useEffect, useState } from 'react';
import { Button, Form, Header, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { API, showError, showSuccess } from '../helpers';

const PayloadArchiveSetting = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState({ configured: false, dialect: '' });
  const [dsn, setDsn] = useState('');
  const [busy, setBusy] = useState('');

  const loadStatus = async () => {
    const res = await API.get('/api/option/payload_archive');
    if (res && res.data && res.data.success) setStatus(res.data.data);
  };
  useEffect(() => { loadStatus().then(); }, []);

  const test = async () => {
    setBusy('test');
    const res = await API.post('/api/option/payload_archive/test', { dsn });
    setBusy('');
    if (res && res.data && res.data.success) showSuccess(t('setting.operation.payload.test_ok'));
    else showError(res && res.data && res.data.message);
  };

  const save = async (value) => {
    setBusy('save');
    const res = await API.put('/api/option/', { key: 'PayloadArchiveDSNSecret', value });
    setBusy('');
    if (res && res.data && res.data.success) {
      showSuccess(t('setting.operation.payload.saved'));
      setDsn('');
      loadStatus().then();
    } else showError(res && res.data && res.data.message);
  };

  return (
    <>
      <Header as='h3'>{t('setting.operation.payload.title')}</Header>
      <p style={{ color: 'var(--text-muted)' }}>{t('setting.operation.payload.rule')}</p>
      <Message size='small' info={status.configured}>
        {status.configured
          ? t('setting.operation.payload.configured', { dialect: status.dialect })
          : t('setting.operation.payload.not_configured')}
      </Message>
      <Form.Input
        label={t('setting.operation.payload.dsn')}
        type='password'
        autoComplete='new-password'
        placeholder={t('setting.operation.payload.dsn_placeholder')}
        value={dsn}
        onChange={(_, { value }) => setDsn(value)}
      />
      <Button type='button' onClick={test} loading={busy === 'test'} disabled={!dsn.trim() || !!busy}>
        {t('setting.operation.payload.test')}
      </Button>
      <Button type='button' primary onClick={() => save(dsn)} loading={busy === 'save'} disabled={!dsn.trim() || !!busy}>
        {t('setting.operation.payload.save')}
      </Button>
      {status.configured && (
        <Button type='button' basic negative onClick={() => save('')} disabled={!!busy}>
          {t('setting.operation.payload.clear')}
        </Button>
      )}
    </>
  );
};

export default PayloadArchiveSetting;
